
import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';

import {
  Row,
  Col,
  Divider,
  // DatePicker,
} from 'antd';

import FormControl, { Select } from 'Components/commonComponents/FormControl';
import { TextField } from 'Pages/DataGatewayPage/routerForm/utils';


const Form = ({ formikControl, sedes, vendedores }) => {
  // // Serializar las sedes para pasárselas al Select del form
  const serializedSedes = sedes.map((sede) => ({ label: sede.name, value: sede.id }));

  return (
    <form onSubmit={formikControl.handleSubmit}>
      <Divider />
      <Row style={{ marginBottom: '12px' }}>
        <Col span={8}>
          <Select
            label="Sede"
            value={formikControl.values.sede}
            options={serializedSedes}
            onChange={(value) => formikControl.setFieldValue('sede', value)}
            error={formikControl.errors.sede}
          />
        </Col>
        <Col span={16}>
          {vendedores.length ? (
            <Select
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              label="Vendedor"
              value={formikControl.values.vendedor}
              options={vendedores.map((vendedor) => ({ value: vendedor.id, label: vendedor.nombre }))}
              onChange={(value) => formikControl.setFieldValue('vendedor', value)}
              error={formikControl.errors.vendedor}
            />
          ) : (
            <FormControl
              label="Vendedor"
              FieldComponent={() => (
                <div style={{ border: '1px solid #d9d9d9', padding: '2px 10px', height: '32px' }}>{formikControl.values.vendedor && formikControl.values.vendedor_name}</div>
              )}
              disabled
              error={formikControl.errors.vendedor}
            />
          )}
        </Col>
        <Col span={24}>
        <div style={{ padding: '0 6px', marginBottom: '12px' }}>
          <span>Observaciones</span>
          <TextField
            placeholder="Observaciones"
            name="observaciones"
            onChange={(e) => formikControl.setFieldValue('observaciones', (e.target.value || ''))}
            value={formikControl.values.observaciones}
          />
        </div>
        </Col>
      </Row>
    </form>
  );
};

Form.defaultProps = {
  sedes: [],
  vendedores: [],
};

Form.propTypes = {
  formikControl: PropTypes.any.isRequired,
  // quotation: PropTypes.shape({
  //   created_by_data: PropTypes.shape({
  //     sedes: PropTypes.array,
  //   }),
  // }),
  sedes: PropTypes.array,
  vendedores: PropTypes.array,
};

export default Form;
